import DetailSlugRow from './DetailSlugRow'

export default DetailSlugRow
